import React from 'react';
import { useApp } from '../../context/AppContext';
import { FileText, Download, Maximize2 } from 'lucide-react';

const LegalCertificates = () => {
    const { legalDocs } = useApp();

    // Filter only file type documents (images/pdfs)
    const certificates = legalDocs.filter(doc => doc.type === 'file' || (!doc.type && doc.fileUrl));

    return (
        <div className="pt-24 pb-16 min-h-screen bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12">
                    <h1 className="text-3xl md:text-5xl font-black text-gray-900 mb-4">Legal Certificates</h1>
                    <p className="text-lg text-gray-500 max-w-2xl mx-auto">
                        Official registrations, licenses, and certifications of Power Clean.
                    </p>
                </div>

                {certificates.length > 0 ? (
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {certificates.map((cert) => (
                            <div key={cert.id} className="bg-white rounded-2xl shadow-md overflow-hidden border border-gray-100 group hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                                <div className="aspect-[4/3] bg-gray-100 relative overflow-hidden">
                                    {cert.fileUrl ? (
                                        <img
                                            src={cert.fileUrl}
                                            alt={cert.title}
                                            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                                        />
                                    ) : (
                                        <div className="w-full h-full flex items-center justify-center text-gray-400">
                                            <FileText className="w-12 h-12" />
                                        </div>
                                    )}
                                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all flex items-center justify-center opacity-0 group-hover:opacity-100">
                                        <a
                                            href={cert.fileUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="bg-white text-gray-900 px-4 py-2 rounded-lg font-bold flex items-center gap-2 transform translate-y-4 group-hover:translate-y-0 transition-all duration-300"
                                        >
                                            <Maximize2 className="w-4 h-4" />
                                            View Full Size
                                        </a>
                                    </div>
                                </div>
                                <div className="p-6">
                                    <h3 className="text-xl font-bold text-gray-900 mb-2">{cert.title}</h3>
                                    {cert.description && (
                                        <p className="text-gray-500 text-sm mb-4 line-clamp-2">{cert.description}</p>
                                    )}
                                    <div className="flex items-center justify-between pt-4 border-t border-gray-50">
                                        <span className="text-xs font-semibold text-gray-400 uppercase tracking-wider">
                                            {new Date(cert.date).toLocaleDateString()}
                                        </span>
                                        <a
                                            href={cert.fileUrl}
                                            download
                                            className="text-primary-600 hover:text-primary-700 text-sm font-bold flex items-center gap-1"
                                        >
                                            <Download className="w-4 h-4" />
                                            Download
                                        </a>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="text-center py-20 bg-white rounded-3xl border border-gray-100 shadow-sm">
                        <div className="w-20 h-20 bg-gray-50 rounded-full flex items-center justify-center mx-auto mb-6 text-gray-400">
                            <FileText className="w-10 h-10" />
                        </div>
                        <h3 className="text-2xl font-bold text-gray-900 mb-2">No Certificates Found</h3>
                        <p className="text-gray-500">Legal documents will be uploaded here shortly.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default LegalCertificates;
